import { ProfilePageBloc } from "@uiview/pages/profile/ProfilePageBloc";
import { createContext } from "react";
export const MyAccountBlocContext = createContext<ProfilePageBloc | undefined>(undefined);
